import { z } from 'zod';
// ─── SQL client: saved queries ───────────────────────────────────────────────
/**
 * An optional text field the console may send blank: trimmed, and an empty
 * value read as "none" so a cleared category stops grouping the query rather
 * than filing it under an empty heading.
 */
function optionalText(max) {
    return z
        .string()
        .trim()
        .max(max)
        .nullable()
        .optional()
        .transform((value) => (value === undefined || value === null || value === '' ? null : value));
}
/**
 * One entry of the SQL client's shared query library — `SaveQueryInput` from
 * `@speles7172/sql-console`. With an `id` it overwrites that entry; without one
 * it creates a new one.
 *
 * `sql` is kept exactly as written (never trimmed): it is what runs, and a
 * statement's own whitespace is the author's.
 */
export const saveSqlQuerySchema = z.object({
    id: z.string().uuid().optional(),
    name: z.string().trim().min(1).max(200),
    sql: z
        .string()
        .max(100_000)
        .refine((value) => value.trim() !== '', { message: 'A saved query needs some SQL.' }),
    database: optionalText(200),
    description: optionalText(1000),
    category: optionalText(120),
});
/** `/admin/sql/saved-queries/:id` — an id that is not a uuid is a 400, never a database error. */
export const savedSqlQueryParamsSchema = z.object({ id: z.string().uuid() });
//# sourceMappingURL=sql-console.js.map